import React from "react";
import { ChevronDown } from "lucide-react";

/**
 * Collapsible section header for the Phases & tasks / Your Journey list.
 * Mirrors the mobile app pattern synced via feature/sync-master:
 *
 *   ▸ Left side  — button showing the section title + chevron. Rotates
 *                  when the section is open; click toggles the whole
 *                  section (all phase cards collapse below).
 *   ▸ Right side — pill button "Expand all" ⇄ "Collapse all" — flips based
 *                  on whether every phase is currently open.
 *
 * Kept small and stateless so the same JSX renders on iPad and desktop
 * regardless of surrounding page width.
 */
export default function PhasesHeader({
    title = "Phases & tasks",
    open,
    onToggleSection,
    allExpanded,
    onExpandAll,
    onCollapseAll,
    testidPrefix = "phases",
}) {
    return (
        <div className="mb-3 flex items-center gap-3">
            <button
                type="button"
                onClick={onToggleSection}
                aria-expanded={open}
                data-testid={`${testidPrefix}-section-toggle`}
                className="flex items-center gap-2 text-lg text-[#131B2F] font-medium hover:opacity-80 transition-opacity"
            >
                <ChevronDown
                    size={16}
                    strokeWidth={1.75}
                    className={`text-[#4B5565] transition-transform duration-200 ${open ? "rotate-0" : "-rotate-90"}`}
                    aria-hidden="true"
                />
                {title}
            </button>

            <div className="flex-1" />

            {open && (
                <button
                    type="button"
                    onClick={allExpanded ? onCollapseAll : onExpandAll}
                    data-testid={`${testidPrefix}-expand-toggle`}
                    className="inline-flex items-center gap-1.5 px-3 h-8 rounded-full text-xs font-medium border border-[#E5E7EB] bg-white text-[#131B2F] hover:bg-[#F5F5F7] transition-colors"
                >
                    {allExpanded ? "Collapse all" : "Expand all"}
                </button>
            )}
        </div>
    );
}
